<template>
  <div v-if="show">
    <div class="modal fade show" tabindex="-1" role="dialog" aria-modal="true" style="display: block;">
      <div class="modal-dialog modal-lg modal-dialog-centered onboarding-modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ currentStep.title }}</h5>
            <button type="button" class="btn-close" aria-label="Close" @click="$emit('close')"></button>
          </div>

          <div class="modal-body">
            <div v-if="currentStep.image_url && !isFinalEfirmaStep" class="onboarding-image-wrap mb-3">
              <img :src="currentStep.image_url" :alt="currentStep.title" class="onboarding-image" />
            </div>

            <div v-if="isFinalEfirmaStep" class="onboarding-efirma-wrap">
              <div v-if="efirma.submitError" class="alert alert-danger py-2" role="alert">{{ efirma.submitError }}</div>

              <div class="onboarding-final-layout">
                <div class="onboarding-final-image-panel">
                  <div class="onboarding-image-wrap onboarding-final-image-wrap">
                    <img :src="finalStepImageUrl" :alt="currentStep.title" class="onboarding-image onboarding-final-image" />
                  </div>
                </div>

                <div class="onboarding-final-form-panel">
                  <div class="row g-3 mb-3">
                    <div class="col-12 col-md-6">
                      <div class="rfcs-upload-box" :class="{ 'rfcs-upload-box-invalid': !!efirma.errors.cer }">
                        <div class="rfcs-upload-icon"><i class="fa fa-cloud-upload"></i></div>
                        <h6>Certificado (.cer)</h6>
                        <p>Sube tu archivo .CER</p>
                        <button type="button" class="btn btn-light" @click="triggerCerFileInput">Seleccionar archivo</button>
                        <small class="d-block mt-2 text-muted rfcs-file-name" :title="efirma.cerFileName || 'Ningun archivo seleccionado'">
                          {{ efirma.cerFileName || 'Ningun archivo seleccionado' }}
                        </small>
                        <input ref="cerInput" class="d-none" type="file" accept=".cer" @change="onCerFileChange" />
                        <small v-if="efirma.errors.cer" class="text-danger d-block mt-2">{{ efirma.errors.cer }}</small>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="rfcs-upload-box" :class="{ 'rfcs-upload-box-invalid': !!efirma.errors.key }">
                        <div class="rfcs-upload-icon"><i class="fa fa-cloud-upload"></i></div>
                        <h6>Clave privada (.key)</h6>
                        <p>Sube tu archivo .KEY</p>
                        <button type="button" class="btn btn-light" @click="triggerKeyFileInput">Seleccionar archivo</button>
                        <small class="d-block mt-2 text-muted rfcs-file-name" :title="efirma.keyFileName || 'Ningun archivo seleccionado'">
                          {{ efirma.keyFileName || 'Ningun archivo seleccionado' }}
                        </small>
                        <input ref="keyInput" class="d-none" type="file" accept=".key" @change="onKeyFileChange" />
                        <small v-if="efirma.errors.key" class="text-danger d-block mt-2">{{ efirma.errors.key }}</small>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="form-label mb-1">Contrasena e.firma</label>
                    <input
                      v-model="efirma.password"
                      type="password"
                      class="form-control"
                      :class="{ 'is-invalid': !!efirma.errors.password }"
                      autocomplete="off"
                      @input="efirma.errors.password = ''"
                    />
                    <small v-if="efirma.errors.password" class="text-danger d-block mt-1">{{ efirma.errors.password }}</small>
                  </div>

                  <div class="row g-3 mb-3">
                    <div class="col-12 col-md-6">
                      <label class="form-label mb-1">Nombre detectado</label>
                      <input v-model="efirma.name" type="text" class="form-control readonly-field" readonly />
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label mb-1">RFC detectado</label>
                      <input v-model="efirma.rfc" type="text" class="form-control readonly-field" readonly />
                    </div>
                  </div>

                  <div class="row g-3">
                    <div class="col-12 col-md-6">
                      <label class="form-label mb-1">Inicio vigencia</label>
                      <input v-model="efirma.startDate" type="text" class="form-control readonly-field" readonly />
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label mb-1">Fin vigencia</label>
                      <input v-model="efirma.endDate" type="text" class="form-control readonly-field" readonly />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="modal-footer d-flex justify-content-between">
            <div>
              <button
                v-if="showPreviousButton"
                type="button"
                class="btn btn-light me-2"
                @click="$emit('previous')"
              >
                Anterior
              </button>
              <button
                v-if="showSecondaryButton"
                type="button"
                class="btn btn-light"
                @click="$emit('secondary')"
              >
                {{ secondaryButtonLabel }}
              </button>
            </div>

            <button
              v-if="showPrimaryButton"
              type="button"
              class="btn btn-primary"
              :disabled="isFinalEfirmaStep && efirma.isSubmitting"
              @click="onPrimaryAction"
            >
              {{ primaryButtonLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import forge from 'node-forge';
import rfcsService from '@/services/rfcs';
import finalStepImage from '@/assets/images/svg-icon/shield.svg';

export default {
  name: 'OnboardingFlowModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    steps: {
      type: Array,
      default: () => [],
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      efirma: {
        cerFile: null,
        cerFileName: '',
        keyFile: null,
        keyFileName: '',
        password: '',
        rfc: '',
        name: '',
        startDate: '',
        endDate: '',
        isSubmitting: false,
        submitError: '',
        errors: {
          cer: '',
          key: '',
          password: '',
        },
      },
    };
  },
  computed: {
    currentStep() {
      if (!this.steps.length) {
        return {
          title: 'Onboarding',
          description: '',
          secondary_text: '',
          image_url: '',
          primary_cta_label: 'Continuar',
          secondary_cta_label: '',
          secondary_cta_action: '',
          key: '',
        };
      }

      const safeIndex = Math.max(0, Math.min(this.currentIndex, this.steps.length - 1));
      return this.steps[safeIndex];
    },
    isFinalEfirmaStep() {
      return String(this.currentStep?.key || '') === 'upload_efirma';
    },
    showPreviousButton() {
      return this.currentIndex > 0;
    },
    showSecondaryButton() {
      const action = String(this.currentStep.secondary_cta_action || '').trim();

      if (!this.currentStep.secondary_cta_label) {
        return false;
      }

      if (action === 'prev_step' && this.showPreviousButton) {
        return false;
      }

      return true;
    },
    showPrimaryButton() {
      return true;
    },
    secondaryButtonLabel() {
      const secondaryAction = String(this.currentStep.secondary_cta_action || '').trim();
      if (this.currentIndex === 0 && secondaryAction === 'skip_onboarding') {
        return 'No volver a mostrar';
      }

      return this.currentStep.secondary_cta_label || 'Secundario';
    },
    primaryButtonLabel() {
      if (this.isFinalEfirmaStep) {
        return this.efirma.isSubmitting ? 'Registrando...' : 'Registrar RFC y e.firma';
      }

      return this.currentStep.primary_cta_label || 'Continuar';
    },
    finalStepImageUrl() {
      return this.currentStep.image_url || finalStepImage;
    },
  },
  methods: {
    onPrimaryAction() {
      if (this.isFinalEfirmaStep) {
        this.submitEfirma();
        return;
      }

      this.$emit('primary');
    },
    clearEfirmaErrors() {
      this.efirma.errors.cer = '';
      this.efirma.errors.key = '';
      this.efirma.errors.password = '';
      this.efirma.submitError = '';
    },
    onKeyFileChange(event) {
      this.efirma.keyFile = event?.target?.files?.[0] || null;
      this.efirma.keyFileName = this.efirma.keyFile ? this.efirma.keyFile.name : '';
      this.efirma.errors.key = '';
    },
    triggerCerFileInput() {
      this.$refs.cerInput?.click();
    },
    triggerKeyFileInput() {
      this.$refs.keyInput?.click();
    },
    async onCerFileChange(event) {
      this.efirma.cerFile = event?.target?.files?.[0] || null;
      this.efirma.cerFileName = this.efirma.cerFile ? this.efirma.cerFile.name : '';
      this.efirma.errors.cer = '';

      if (!this.efirma.cerFile) {
        this.efirma.rfc = '';
        this.efirma.name = '';
        this.efirma.startDate = '';
        this.efirma.endDate = '';
        return;
      }

      try {
        const arrayBuffer = await this.efirma.cerFile.arrayBuffer();
        const uint8Array = new Uint8Array(arrayBuffer);
        let binary = '';

        for (let i = 0; i < uint8Array.byteLength; i++) {
          binary += String.fromCharCode(uint8Array[i]);
        }

        const der = forge.util.createBuffer(binary, 'raw');
        const asn1 = forge.asn1.fromDer(der);
        const cert = forge.pki.certificateFromAsn1(asn1);

        const attrs = cert.subject.attributes || [];
        const rfcAttr = attrs.find((attr) => attr.type === '2.5.4.45');
        const nameAttr = attrs.find((attr) => attr.type === '2.5.4.3');

        const rfcParts = String(rfcAttr?.value || '')
          .split('/')
          .map((part) => part.trim())
          .filter(Boolean);

        this.efirma.rfc = String(rfcParts[0] || '').toUpperCase();
        this.efirma.name = String(nameAttr?.value || rfcParts[1] || '');

        const formatDate = (date) => date.toLocaleDateString('es-MX', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });

        this.efirma.startDate = formatDate(cert.validity.notBefore);
        this.efirma.endDate = formatDate(cert.validity.notAfter);
      } catch (error) {
        this.efirma.errors.cer = 'No se pudo leer el archivo .cer';
      }
    },
    validateEfirmaForm() {
      this.clearEfirmaErrors();

      if (!this.efirma.cerFile) {
        this.efirma.errors.cer = 'Selecciona el archivo .cer';
      }

      if (!this.efirma.keyFile) {
        this.efirma.errors.key = 'Selecciona el archivo .key';
      }

      if (!String(this.efirma.password || '').trim()) {
        this.efirma.errors.password = 'Captura la contrasena de e.firma';
      }

      if (!String(this.efirma.rfc || '').trim()) {
        this.efirma.errors.cer = this.efirma.errors.cer || 'No se pudo detectar RFC desde el .cer';
      }

      return !this.efirma.errors.cer && !this.efirma.errors.key && !this.efirma.errors.password;
    },
    async submitEfirma() {
      if (!this.validateEfirmaForm()) {
        return;
      }

      this.efirma.isSubmitting = true;
      this.efirma.submitError = '';

      try {
        const payload = new FormData();
        payload.append('cer_file', this.efirma.cerFile);
        payload.append('key_file', this.efirma.keyFile);
        payload.append('fiel_password', this.efirma.password);
        payload.append('rfc', this.efirma.rfc);
        payload.append('name', this.efirma.name || this.efirma.rfc);

        const response = await rfcsService.storeRFC(payload, { skipLoading: true });

        if (!response || response.type !== 'success') {
          this.efirma.submitError = response?.message || 'No se pudo registrar la e.firma.';
          return;
        }

        if (this.$toast?.success) {
          this.$toast.success(response.message || 'e.firma registrada correctamente.');
        }

        this.$emit('efirma-registered', {
          rfcs: Array.isArray(response.data) ? response.data : [],
          registeredRfc: String(this.efirma.rfc || '').trim().toUpperCase(),
        });

        this.efirma.cerFile = null;
        this.efirma.cerFileName = '';
        this.efirma.keyFile = null;
        this.efirma.keyFileName = '';
        this.efirma.password = '';
      } catch (error) {
        this.efirma.submitError = error?.response?.data?.message || 'No se pudo registrar la e.firma.';
      } finally {
        this.efirma.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.onboarding-efirma-wrap {
  border: 1px solid rgba(115, 102, 255, 0.16);
  border-radius: 12px;
  padding: 12px;
  background: rgba(115, 102, 255, 0.04);
}

.onboarding-final-layout {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.onboarding-final-image-panel,
.onboarding-final-form-panel {
  min-width: 0;
}

.rfcs-upload-box {
  border: 2px solid transparent;
  border-radius: 14px;
  padding: 16px 14px;
  text-align: center;
  background:
    linear-gradient(var(--bs-white, #fff), var(--bs-white, #fff)) padding-box,
    linear-gradient(90deg, #ed6793, #5d62a9, #72c6ff) border-box;
}

.rfcs-upload-icon {
  width: 50px;
  height: 50px;
  margin: 0 auto 10px;
  border-radius: 50%;
  display: inline-grid;
  place-items: center;
  background-color: #f2f3f8;
  color: var(--theme-deafult, #7366ff);
  font-size: 18px;
}

.rfcs-upload-box h6 {
  margin-bottom: 6px;
}

.rfcs-upload-box p {
  margin-bottom: 10px;
  color: #6c757d;
}

.rfcs-upload-box-invalid {
  border-color: #dc3545;
}

.rfcs-file-name {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.readonly-field {
  background-color: #e9ecef;
}

.onboarding-final-form-panel .form-control {
  width: 100%;
}

.onboarding-final-image-wrap {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.onboarding-final-image {
  width: 100%;
  max-width: 100%;
  max-height: none;
  height: 100%;
  object-fit: contain;
}

@media (max-width: 768px) {
  .onboarding-final-layout {
    grid-template-columns: 1fr;
  }
}

.onboarding-image-wrap {
  border: 1px solid rgba(115, 102, 255, 0.2);
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(115, 102, 255, 0.08) 0%, rgba(247, 49, 100, 0.05) 100%);
  padding: 14px;
  text-align: center;
  overflow: visible;
}

.onboarding-image {
  display: block;
  margin: 0 auto;
  width: 100%;
  object-fit: contain;
}

.onboarding-modal-dialog {
  max-width: 980px;
}

@media (max-width: 992px) {
  .onboarding-modal-dialog {
    max-width: 92vw;
  }
}
</style>
